import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { TILE_SIZES, type TileSize } from 'dibs-buyer-product-tile/exports/BuyerProductTile';

export const useBuyerProductTileSize = (): Extract<TileSize, 'small' | 'large'> => {
    const { isDesktop } = useServerVarsContext();
    return isDesktop ? TILE_SIZES.large : TILE_SIZES.small;
};
